import React from 'react';

const Home = () => (
  <div className="SectionContainer">
    <div className="ChalkBoard SectionContentContainer">
      <div className="SectionContent">
        <h2>Welcome to Math Magicians App!</h2>
        <p>
          This is a React web app for all fans of mathematics.
          It is a Single Page App (SPA) that allows you to:
        </p>
        <ul>
          <li>Make simple calculations</li>
          <li>Read a random math-related quote</li>
        </ul>
      </div>
    </div>
  </div>
);

export default Home;
